import React, { useEffect, useState } from "react";
import { Accordion, Card, Badge, Table } from 'react-bootstrap';
import axios from "axios";
import Layout from '../../components/layouts/Main';
import config from '../../config';
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";

export default function ApprovedQuotations() {
  const [approvedQuotations, setApprovedQuotations] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const fetchApprovedQuotations = async () => {
    setIsLoading(true);
    try {
      const res = await axios.get(`${config.API_BASE_URL}/rfq-responses/approved/unlinked`);
      setApprovedQuotations(res.data || []);
    } catch (err) {
      console.error("Error fetching approved quotations", err);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchApprovedQuotations();
  }, []);

  return (
    <Layout>
      {/* Breadcrumb */}
      <nav aria-label="breadcrumb" className="mb-3">
        <ol className="breadcrumb">
          <li className="breadcrumb-item"><Link to="/purchase-orders">Purchase Orders</Link></li>
          <li className="breadcrumb-item active">Purchase Orders</li>
        </ol>
      </nav>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Approved Quotations</h2>
      </div>

      {isLoading ? (
        <PulseLoader
          color="#014b7cbb"
          size={9}
        />
      ) : (
        <Accordion defaultActiveKey="0">
          {approvedQuotations.map((quote, index) => (
            <Card key={quote._id} className="mb-2">
              <Accordion.Item eventKey={index.toString()}>
                <Accordion.Header>
                  <span className="me-2">#{quote.quotationId}</span>
                  <Badge bg="success" className="me-2">
                    Approved - {new Date(quote.updatedAt).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    })}
                  </Badge>
                </Accordion.Header>
                <Accordion.Body className="p-2 p-sm-3">
                  <p><strong>By:</strong> {quote.rfq_recipient.recipient_type} - {quote.rfq_recipient.recipient_id?.business_name}</p>
                  <p><strong>Expected Delivery:</strong> {new Date(quote.expected_delivery_date).toLocaleDateString('en-IN', {
                    day: '2-digit',
                    month: 'short',
                    year: 'numeric',
                  })}</p>
                  <p><strong>Note:</strong> {quote.response_notes}</p>
                  <p><strong>Tax:</strong> {quote.tax || 'N/A'}%</p>

                  <Table bordered size="sm" className="mt-3">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Quantity</th>
                        <th>Quality</th>
                        <th>Unit Price</th>
                        <th>Total Price</th>
                      </tr>
                    </thead>
                    <tbody>
                      {quote.items?.map((item, i) => (
                        <tr key={i}>
                          <td>{item.product?.productName}</td>
                          <td>{item.quantity} {item.quantity_unit}</td>
                          <td>{item.quality}</td>
                          <td>₹ {item.unit_rate}</td>
                          <td>₹ {item.total_price}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  <div className="text-end mt-3">
                    <Link
                      to={`/new-purchase-order/${quote._id}`}
                      className="btn btn-primary"
                    >
                      Raise Purchase Order
                    </Link>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Card>
          ))}
        </Accordion>
      )}

      {/* <PurchaseOrderWizard
        show={showWizard}
        onClose={() => {
          setShowWizard(false);
        }}
        editData={editData}
      /> */}
    </Layout>
  );
}
